import * as React from 'react'
import { GlobalLoader, loadersSlice, LocalStorage } from 'Modules'
import { withRouter } from 'react-router-dom'
import ArticleViewContainer from 'Pages/knowledge/articles/containers/ArticleView'
import { useAppDispatch, useEffectOnce } from 'Src/hooks'
import { i18n, TextType, Text, FontWeightType } from 'LibNeo'
import { PublicPageWrapper, PublicPageHeader } from './styled'

const actions = {
	showGlobalLoader: loadersSlice.actions.showGlobalLoader,
}

const PublicPage = () => {
	const { showGlobalLoader } = useAppDispatch(actions)

	useEffectOnce(() => {
		showGlobalLoader()
		LocalStorage.setUserSettings({ redirect: window.location.pathname })
	})

	return (
		<PublicPageWrapper>
			<PublicPageHeader>
				<Text type={TextType.CAPTION} colorIndex={9} fontWeight={FontWeightType.SEMIBOLD}>
					{i18n('nav.knowledge')}
				</Text>
			</PublicPageHeader>
			<ArticleViewContainer />
			<GlobalLoader />
		</PublicPageWrapper>
	)
}

export const PublicPageContainer = withRouter(PublicPage)
